import { render, staticRenderFns } from "./sponsor-dialog.vue?vue&type=template&id=825f1e70&scoped=true"
import script from "./sponsor-dialog.vue?vue&type=script&lang=js"
export * from "./sponsor-dialog.vue?vue&type=script&lang=js"
import style0 from "./sponsor-dialog.vue?vue&type=style&index=0&id=825f1e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "825f1e70",
  null
  
)

export default component.exports